<button mat-flat-button [matMenuTriggerFor]="dynamicmenu.menu">{{dmenu.menu_button_name}}</button>
<app-menu #dynamicmenu [items]="dmenu.items" (notify)="getChildTitle($event)"></app-menu>
